import { useState } from "react";

export function useVinosUI() {
    const [q, setQ] = useState("");
    const [sortBy, setSortBy] = useState("nombre");

    const [openVinos, setOpenVinos] = useState(new Set());
    const toggleVino = (id) =>
        setOpenVinos((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    const isVinoOpen = (id) => openVinos.has(id);

    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    // (lo tenías, aunque ahora siempre false)
    const [autoPrint] = useState(false);

    return {
        q, setQ,
        sortBy, setSortBy,
        toggleVino, isVinoOpen,
        showConfirm, setShowConfirm,
        deleteId, setDeleteId,
        autoPrint,
    };
}
